import { api } from 'app/api';
import { BatchExportTypes } from '../constants';
import { FormDto } from 'dtos';
import { downloadPdf, pad2 } from 'utils';
import { getPdf } from './report';

export const batchExport = (forms: FormDto[], batchExportType: BatchExportTypes) => {
  const today = new Date();
  // yyyymmddhhmmss timestamp
  const timestamp =
    today.getFullYear() +
    pad2(today.getMonth() + 1) +
    pad2(today.getDate()) +
    pad2(today.getHours()) +
    pad2(today.getMinutes()) +
    pad2(today.getSeconds());

  if (batchExportType === BatchExportTypes.SingleFileExport) {
    const requestUrl = `telerik-reports/export?formIds=${forms
      .map(form => form.id?.toString())
      .join(',')}`;

    getPdf(requestUrl).then(pdf => {
      downloadPdf(
        pdf,
        `BatchExport.${forms
          .map(form => form.formNumber?.toString())
          .join('.')}.${timestamp}.pdf`
      );
    });
  } else {
    forms.forEach(form => {
      const requestUrl = `telerik-reports/export?formIds=${form.id}`;

      getPdf(requestUrl).then(pdf =>
        downloadPdf(pdf, `BatchExport.${form.formNumber}.${timestamp}.pdf`)
      );
    });
  }
};

export const batchExport2 = async (batchExportType: string, formNumbers: string[]) =>
  await api
    .get(
      'batch-export?batchExportType=' +
        batchExportType +
        formNumbers.map(formNumber => `&formNumber=${formNumber}`)
    )
    .then(res => res.data);
